import React, { useEffect, useState } from 'react'
import { GetNewsletterGroupsSearchParams } from '../../lib/types'
import { newsletterServices } from '../../services/newsletter-service'
import { NewsletterGroupsListPresenter } from './newsletter-groups-list-presenter'

const DEFAULT_LIMIT = 10
const DEFAULT_SEARCH_PARAMS: GetNewsletterGroupsSearchParams = {
  limit: DEFAULT_LIMIT.toString(),
  offset: '0',
  keyword: '',
  sortBy: 'NEWEST_TO_OLDEST',
}
const DEFAULT_PAGINATION = {
  total: 0,
  limit: DEFAULT_LIMIT,
  count: 0,
  offset: 0,
}

const NewsletterGroupsListContainer = () => {
  const [groups, setGroups] = useState<any[]>([])
  const [searchParams, setSearchParams] =
    useState<GetNewsletterGroupsSearchParams>(DEFAULT_SEARCH_PARAMS)
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchGroups = async () => {
      setIsLoading(true)
      const res = await newsletterServices.getGroups(searchParams)
      if (res?.data?.groups && res.data.groups.length > 0) {
        setGroups(res.data.groups)
        if (res.data.pagination) {
          setPagination(res.data.pagination)
        }
      } else {
        setGroups([])
        setPagination(DEFAULT_PAGINATION)
      }
      setIsLoading(false)
    }
    fetchGroups()
  }, [currentPage, searchParams])

  const handleSearchParams = ({ name, value }: { name: string; value: string }) => {
    const { limit } = DEFAULT_PAGINATION
    setSearchParams((prev) => ({
      ...prev,
      offset: '0',
      limit: limit.toString(),
      [name]: value,
    }))
    setCurrentPage(1)
    setPagination(DEFAULT_PAGINATION)
  }

  const resetSearchParams = () => {
    setSearchParams(DEFAULT_SEARCH_PARAMS)
    setCurrentPage(1)
    setPagination(DEFAULT_PAGINATION)
  }

  const handleCurrentPage = (currentPage: number) => {
    const { limit } = DEFAULT_PAGINATION
    setCurrentPage(currentPage)
    setSearchParams((prev) => ({
      ...prev,
      offset: `${(currentPage - 1) * limit}`,
    }))
    setPagination((prev) => ({ ...prev, offset: (currentPage - 1) * limit }))
  }

  return (
    <NewsletterGroupsListPresenter
      groups={groups}
      isLoading={isLoading}
      pagination={pagination}
      currentPage={currentPage}
      searchParams={searchParams}
      handleCurrentPage={handleCurrentPage}
      handleSearchParams={handleSearchParams}
      resetSearchParams={resetSearchParams}
    />
  )
}

export { NewsletterGroupsListContainer }
